import { render, staticRenderFns } from "./BDSettle.vue?vue&type=template&id=111bc07a&scoped=true&"
import script from "./BDSettle.vue?vue&type=script&lang=js&"
export * from "./BDSettle.vue?vue&type=script&lang=js&"
import style0 from "./BDSettle.vue?vue&type=style&index=0&id=111bc07a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111bc07a",
  null
  
)

export default component.exports